import { SET_DASHBOARD_DATA, SET_SHOP_STATUS, SET_SHOP_WAIT_TIME, SET_SHOP_TYPE } from './constants';

const initialState = {
  today: null,
  pending: null,
  isOnline: false,
  waitTime: 12,
  shopTypeId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_DATA:
      return {
        ...state,
        today: action.payload.today,
        pending: action.payload.pending
      };
    case SET_SHOP_STATUS:
      return {
        ...state,
        isOnline: action.isOnline
      };
    case SET_SHOP_WAIT_TIME:
      return {
        ...state,
        waitTime: action.waitTime
      };
    case SET_SHOP_TYPE:
      return {
        ...state,
        shopTypeId: action.shopTypeId
      };
    default:
      return state;
  }
};

export default reducer;